import { AvatarProvider } from "@buildwithflux/avatar-react-mui";
import { useNavigationAuth } from "@buildwithflux/navigation";
import Box from "@mui/material/Box";
import type { ReactNode } from "react";

import { ViewerProvider } from "../context/ViewerContext";
import { firestoreAvatarAdapter } from "../hooks/useFirestoreAvatarAdapter";

import Header from "./Header";

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    const { user, resolved } = useNavigationAuth();

    return (
        <AvatarProvider adapter={firestoreAvatarAdapter}>
            <ViewerProvider uid={user?.uid ?? null} authResolved={resolved}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: "100vh",
                        bgcolor: "background.default",
                        lineHeight: "normal",
                    }}
                >
                    <Header userInfo={user} authResolved={resolved} />
                    {/* Spacer matching the fixed Header's dense Toolbar height */}
                    <Box sx={{ height: 48 }} />
                    <Box
                        component="main"
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {children}
                    </Box>
                </Box>
            </ViewerProvider>
        </AvatarProvider>
    );
}
